/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsaverageage2Inputs */

const en_signupsaverageage2 = /** @type {(inputs: Signupsaverageage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average age`)
};

const de_signupsaverageage2 = /** @type {(inputs: Signupsaverageage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschnittsalter`)
};

/**
* | output |
* | --- |
* | "Average age" |
*
* @param {Signupsaverageage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsaverageage2 = /** @type {((inputs?: Signupsaverageage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsaverageage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsaverageage2(inputs)
	return de_signupsaverageage2(inputs)
});
export { signupsaverageage2 as "signupsAverageAge" }